import { useMemo } from "react";
import _ from "lodash";

import Box from "components/Box";

import SectionContent from "entities/Memo/components/Sections/SectionContent";
import { IMemoSection } from "entities/Memo/sdk";

import PrintableRichtextfield from "../PrintableMemoRichTextField";

interface IPrintableSectionComment {
  section: IMemoSection;
}

const PrintableSectionComment = ({ section }: IPrintableSectionComment) => {
  const field = useMemo(() => _.first(section.fields), [section]);

  if (!field) {
    return null;
  }

  return (
    <Box data-testid="comment-section">
      <SectionContent>
        <Box
          sx={{
            marginTop: "8px",
            "& .MuiIconButton-root": { visibility: "hidden" },
            "&:hover .MuiIconButton-root": {
              visibility: "visible",
            },
          }}
        >
          <PrintableRichtextfield field={field} isNASection={section.is_na} />
        </Box>
      </SectionContent>
    </Box>
  );
};

export default PrintableSectionComment;
